import PageLayout from '@/components/PageLayout';
import SEO from '@/components/SEO';
import {
  HomeHeroSection,
  HomeAboutSection,
  HomeTechnologySection,
  HomePlatformsSection,
  HomePatentsSection,
  HomeManufacturingSection,
  HomeCapabilitiesSection
} from '@/features/home';
import { ScrollDownIndicator } from '@/features/home/components/ScrollDownIndicator';

const Index = () => {
  return (
    <div className="relative">
      <PageLayout>
        <SEO 
          title="Xenira - Pharmaceutical Drug Delivery Innovation" 
          description="Xenira: Advanced lipid-based drug delivery systems for enhanced bioavailability and therapeutic outcomes." 
          keywords={['drug delivery', 'lipid formulations', 'pharmaceutical technology', 'bioavailability enhancement', 'pharmaceutical development', 'manufacturing']} 
        />
        <HomeHeroSection />
        <ScrollDownIndicator />
        <HomeAboutSection />
        <HomeTechnologySection />
        <HomePlatformsSection />
        <HomePatentsSection />
        <HomeCapabilitiesSection />
        <HomeManufacturingSection />
      </PageLayout>
    </div>
  );
};

export default Index;
